<template>
  <ul class="nav nav-tabs">
    <li :class="{ active: isActiveTab('EventDetails') }">
      <router-link
        :to="{ name: 'EventDetails', params: { event_id: eventId } }"
        >{{ $label("event.general_tab", "General") }}</router-link
      >
    </li>
    <li
      :class="{
        active: isActiveTab('EventDateSettings'),
        'is-disabled': eventId == null
      }"
    >
      <router-link
        :to="{ name: 'EventDateSettings', params: { event_id: eventId } }"
        data-toggle="tab"
        >{{ $label("event.date_settings_tab", "Date settings") }}</router-link
      >
    </li>
    <li
      :class="{
        active: isActiveTab('EventPrices'),
        'is-disabled': eventId == null
      }"
    >
      <router-link
        :to="{ name: 'EventPrices', params: { event_id: eventId } }"
        data-toggle="tab"
        >{{ $label("event.price_settings_tab", "Price settings") }}</router-link
      >
    </li>
    <li
      :class="{
        active: isActiveTab('EventAppointments'),
        'is-disabled': eventId == null
      }"
    >
      <router-link
        :to="{ name: 'EventAppointments', params: { event_id: eventId } }"
        data-toggle="tab"
        >{{ $label("event.appointments_tab", "Appointments") }}</router-link
      >
    </li>
    <li
      :class="{
        active: isActiveTab('EventInventorySettings'),
        'is-disabled': eventId == null
      }"
    >
      <router-link
        :to="{ name: 'EventInventorySettings', params: { event_id: eventId } }"
        data-toggle="tab"
        >{{
          $label("event.inventory_settings_tab", "Inventory settings")
        }}</router-link
      >
    </li>
  </ul>
</template>

<script>
export default {
  name: "NavigationTabs",

  props: ["eventId"],

  methods: {
    isActiveTab(tab) {
      return this.$route.name == tab;
    }
  }
};
</script>

<style scoped></style>
